var Handlebars = require("../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "        <div class=\"mi "
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isDocument : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "\" data-note-type=\""
    + alias2(alias1((depth0 != null ? depth0.noteType : depth0), depth0))
    + "\" data-isdoc=\""
    + alias2(alias1((depth0 != null ? depth0.isDocument : depth0), depth0))
    + "\" title=\""
    + alias2(alias1((depth0 != null ? depth0.actionTitle : depth0), depth0))
    + "\">\n            <span class=\"dd-icon "
    + alias2(alias1((depth0 != null ? depth0.iconClass : depth0), depth0))
    + "\"></span>\n            "
    + alias2(alias1((depth0 != null ? depth0.actionTitle : depth0), depth0))
    + "\n        </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "mi-dn";
},"4":function(container,depth0,helpers,partials,data) {
    return "mi-pg";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div id=\"dd-new-note\" class=\"add-pg-note-list dropdown-menu hide\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.noteTypesToCreate : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n\n";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/header/createNew/addNoteDD.hbs
 ** module id = 491
 ** module chunks = 0
 **/